const UMAMI_HOST = import.meta.env.VITE_UMAMI_HOST;
const SHARE_TOKEN = import.meta.env.VITE_UMAMI_SHARE_TOKEN;
const WEBSITE_DOMAIN = "askcarmen.eu";

export function AdminVisitorsTab() {
  if (!UMAMI_HOST || !SHARE_TOKEN) {
    return (
      <div className="space-y-3 p-6">
        <h1 className="cs-h1 text-[var(--cs-navy)]">Bezoekers</h1>
        <div className="rounded-2xl border border-[rgba(225,29,72,0.20)] bg-[rgba(225,29,72,0.06)] p-4 text-sm text-[var(--cs-rose)]">
          Umami niet geconfigureerd. Stel <code>VITE_UMAMI_HOST</code> en{" "}
          <code>VITE_UMAMI_SHARE_TOKEN</code> in en bouw opnieuw.
        </div>
      </div>
    );
  }

  const dashboardUrl = `${UMAMI_HOST}/share/${SHARE_TOKEN}/${WEBSITE_DOMAIN}`;

  return (
    <div className="space-y-6 p-6">
      <header>
        <h1 className="cs-h1 text-[var(--cs-navy)]">Bezoekers</h1>
        <p className="text-sm text-[var(--cs-ink-muted)]">
          Marketing-site traffic — askcarmen.eu
        </p>
      </header>

      <div className="rounded-2xl border border-[rgba(10,52,96,0.10)] bg-white p-6 shadow-[0_4px_8px_rgba(10,52,96,0.06)]">
        <p className="cs-caption mb-2">Umami dashboard</p>
        <p className="mb-4 text-sm text-[var(--cs-ink-muted)]">
          Pageviews, referrers, bezoekers per land, en CTA-events. Read-only
          share-link — opent in een nieuw tabblad.
        </p>
        <a
          href={dashboardUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full bg-[var(--cs-navy)] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[var(--cs-navy-strong)]"
        >
          Open Bezoekers dashboard
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="h-4 w-4"
            aria-hidden="true"
          >
            <path d="M7 17L17 7M17 7H8M17 7V16" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
      </div>
    </div>
  );
}
